// extracted by mini-css-extract-plugin
module.exports = {"button":"_1uLht","medium":"mQItW","text":"_3MSIe","icon":"K5PUJ"};